<template>
  <div class="back-box">
    <div class="left-back pointer" @click="router.go(-1)">
      <span class="iconfont icon icon-left" />
      返回
    </div>
    <div class="operateList-box">
      <template v-if="edit">
        <RxkButton @click="handleCancel">取消</RxkButton>
        <RxkButton @click="handleSave">保存</RxkButton>
      </template>
      <RxkButton v-else @click="handleEdit">编辑</RxkButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const emit = defineEmits(['handleEdit', 'handleCancel', 'handleSave'])
const edit = ref(false)
const router = useRouter()
function handleEdit() {
  edit.value = true
  emit('handleEdit')
}
function handleCancel() {
  edit.value = false
  emit('handleCancel')
}
function handleSave() {
  emit('handleSave', () => {
    edit.value = false
  })
}
</script>
<style lang="scss" scoped>
.back-box {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 8px 16px;
  align-items: center;
  box-sizing: border-box;
  .left-back {
    color: #999999;
    font-size: 12px;
  }
  .operateList-box {
  }
}
</style>
